import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import tagsReducer from '@app/reducers/entities/tags';

const TAGS_QUERY_NAME = 'tags-selector';
export const LIMIT = 50;

export function useTags() {
  const dispatch = useDispatch();
  const tagsQuery = useSelector((state) =>
    tagsReducer.getQuerySelector(state, {
      name: TAGS_QUERY_NAME,
    }),
  );
  const filterableTags = useSelector(
    (state) =>
      tagsReducer.getTagsSelector(state, {
        ids: tagsQuery.result,
      }),
    shallowEqual,
  );

  const fetch = useCallback(
    (searchValue?: string) => {
      dispatch(
        tagsReducer.queryTags({
          name: TAGS_QUERY_NAME,
          pagination: {
            offset: 0,
            limit: LIMIT,
          },
          params: {
            q: searchValue && searchValue.length > 0 ? searchValue : undefined,
          },
        }),
      );
    },
    [
      dispatch,
    ],
  );

  const loadMore = useCallback(
    (additionalResults: number) => {
      dispatch(
        tagsReducer.queryTagsLoadMore({
          name: TAGS_QUERY_NAME,
          additionalResults,
        }),
      );
    },
    [
      dispatch,
    ],
  );

  return {
    fetch,
    loadMore,
    data: filterableTags,
    loading: tagsQuery.status === 'loading',
    error: tagsQuery.status === 'error',
    pristine: tagsQuery.status === 'pristine',
    success: tagsQuery.status === 'success',
    count: tagsQuery.count,
  };
}
